/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SaveDealWithJournalizing200ResponseJournalEntriesInner
 */
export interface SaveDealWithJournalizing200ResponseJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'invalidTaxCodeCause': SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealWithJournalizing200ResponseJournalEntriesInner
     */
    'description': string | null;
}

export const SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof SaveDealWithJournalizing200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum];


